/* istanbul ignore file */
import React from 'react';
import ProjectBreadcrumbs from 'domain/projects/project/shared/ProjectBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateProjectBreadcrumbs = () => {
  return (
    <ProjectBreadcrumbs>
      <CreateBreadcrumbItem entity="Project" />
    </ProjectBreadcrumbs>
  );
};

export default CreateProjectBreadcrumbs;
